<template>
<w-sliding-popup ref="slidingPopup" title="이미지 선택" width="450px" :defaultContent="false">
  <w-custom-image-list slot="content" ref="customImageList" style="height: 100%; padding: 25px;" @selectedImage="onSelectedImage"></w-custom-image-list>
  <div slot="footer">
    <el-button size="large" type="solid" @click="onSaveClick">확인</el-button>
    <el-button size="large" @click="close">취소</el-button>
  </div>
</w-sliding-popup>
</template>

<script>
import msgUtil from '@/utils/message';
import { isEmpty } from '@/utils/basic';

import DashboardConst from '@/constants/dashboard';

import WCustomImageList from '@/views/dashboard/components/CustomImageList';

export default {
  name: 'WImageSelectPopup',
  components: {
    WCustomImageList,
  },
  data() {
    return {
      selectedImage: null,
    };
  },
  created() {
    this.$dashboardEventBus.$on(DashboardConst.EVENT_BUS.IMAGE_SELECT_POPUP, this.open);
  },
  beforeDestroy() {
    this.$dashboardEventBus.$off(DashboardConst.EVENT_BUS.IMAGE_SELECT_POPUP, this.open);
  },
  methods: {
    /**
     * 팝업 오픈 요청
     * @author KangBonghun(toto1323)
     * @param  {[type]} params [description]
     */
    open() {
      this.$refs.slidingPopup.open();

      this.loadData();
    },
    /**
     * 팝업 닫기 요청
     * @author KangBonghun(toto1323)
     */
    close() {
      this.$refs.slidingPopup.close();
      this.selectedImage = null;
    },
    loadData() {
      if (!isEmpty(this.$refs.customImageList)) {
        this.$refs.customImageList.loadData();
      }
    },
    onSaveClick() {
      const selectedImage = this.selectedImage;

      if (isEmpty(selectedImage)) {
        this.$message(msgUtil.getCustomMsgData('이미지를 선택해주십시오.'));
      } else {
        this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.IMAGE_SELECT, selectedImage);
        this.close();
      }
    },
    onSelectedImage(selectedImage) {
      this.selectedImage = selectedImage;
    },
  },
};
</script>

<style module>
<style module>
.table {
  width: 100%;
}

.row {
  height: 100px;
  line-height: 100px;
  width: 100%;
  vertical-align: middle;
}

.img {
  height: 100%;
  width: 100%;
}

.combobox {
  width: 100%;
  margin-right: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/popup/ImageSelectPopup.vue